module.exports = __webpack_public_path__ + "img/IND-i-2-V.23be9419.png";